import { render, staticRenderFns } from "./addtokenMg.vue?vue&type=template&id=192507bc&"
import script from "./addtokenMg.vue?vue&type=script&lang=js&"
export * from "./addtokenMg.vue?vue&type=script&lang=js&"
import style0 from "./addtokenMg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192507bc')) {
      api.createRecord('192507bc', component.options)
    } else {
      api.reload('192507bc', component.options)
    }
    module.hot.accept("./addtokenMg.vue?vue&type=template&id=192507bc&", function () {
      api.rerender('192507bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/facebook/components/addtokenMg.vue"
export default component.exports